module.exports = __webpack_public_path__ + "static/media/deco.e940c993.png";